module.exports = __webpack_public_path__ + "img/checked_white_icon.ec824557.svg";